import React, { useContext } from "react";
import { LanguageContext } from '../../../index';
import serviceImg1 from "@images/services/serwis-main.webp";
import serviceImg2 from "@images/services/serwis-1.webp";
import serviceImg3 from "@images/services/serwis-2.webp";

const ServicesServiceContent = ({ sTitle }) => {
    const { language } = useContext(LanguageContext);

    const content = {
        pl: {
            main: [
                "Oferujemy kompleksowe usługi w zakresie renowacji i konserwacji podłóg drewnianych, parkietów oraz schodów. Specjalizujemy się w profesjonalnym cyklinowaniu, lakierowaniu, olejowaniu, bejcowaniu oraz naprawach zniszczonych powierzchni drewnianych. Dzięki wieloletniemu doświadczeniu i nowoczesnym technologiom przywracamy podłogom ich dawny blask i trwałość.",
                "Cyklinowanie pozwala usunąć zarysowania, przebarwienia oraz inne ślady użytkowania, przygotowując powierzchnię do dalszych zabiegów. Lakierowanie i olejowanie zabezpieczają drewno, podkreślając jego naturalne piękno i strukturę. Bejcowanie umożliwia nadanie podłodze wybranego koloru, a konserwacja i regularna pielęgnacja gwarantują jej długowieczność.",
                "Wykonujemy również reperacje uszkodzonych fragmentów podłóg i schodów, wymianę pojedynczych desek oraz uzupełnianie ubytków. Nasze usługi realizujemy zarówno w domach prywatnych, jak i w obiektach komercyjnych na terenie Małopolski, w tym w Krakowie."
            ],
            scopeTitle: "Zakres naszych usług",
            scopeList: [
                "Profesjonalne cyklinowanie podłóg, parkietów i schodów",
                "Lakierowanie i olejowanie powierzchni drewnianych",
                "Bejcowanie i nadawanie nowego koloru podłogom",
                "Konserwacja i zabezpieczanie drewna",
                "Reperacje i naprawy uszkodzonych fragmentów"
            ],
            whyTitle: "Dlaczego warto skorzystać z naszych usług?",
            why: "Stawiamy na najwyższą jakość wykonania oraz indywidualne podejście do każdego zlecenia. Korzystamy z profesjonalnych maszyn i sprawdzonych środków, dzięki czemu podłogi odzyskują swój pierwotny wygląd i są odpowiednio zabezpieczone na lata. Gwarantujemy terminowość, rzetelność oraz fachowe doradztwo na każdym etapie realizacji."
        },
        en: {
            main: [
                "We offer comprehensive services in the renovation and maintenance of wooden floors, parquet, and stairs. We specialize in professional sanding, varnishing, oiling, staining, and repairing damaged wooden surfaces. With many years of experience and modern technology, we restore floors to their former glory and durability.",
                "Sanding removes scratches, discolorations, and other signs of use, preparing the surface for further treatments. Varnishing and oiling protect the wood, highlighting its natural beauty and structure. Staining allows you to give the floor your chosen color, while maintenance and regular care ensure its longevity.",
                "We also repair damaged floor and stair fragments, replace individual boards, and fill gaps. Our services are provided in both private homes and commercial facilities in the Małopolska region, including Kraków."
            ],
            scopeTitle: "Scope of our services",
            scopeList: [
                "Professional sanding of floors, parquet, and stairs",
                "Varnishing and oiling of wooden surfaces",
                "Staining and giving floors a new color",
                "Maintenance and protection of wood",
                "Repairs and restoration of damaged sections"
            ],
            whyTitle: "Why choose our services?",
            why: "We focus on the highest quality workmanship and an individual approach to each project. We use professional machines and proven products, so your floors regain their original appearance and are properly protected for years. We guarantee timeliness, reliability, and expert advice at every stage of the process."
        }
    };

    const t = content[language] || content.pl;

    return (
        <div className="service-single-wrap">
            <div className="service-single-item">
                <div className="service-single-main-img">
                    <img src={serviceImg1} alt={sTitle} />
                </div>
                <div className="service-single-title">
                    <h3>{sTitle}</h3>
                </div>
                {t.main.map((p, i) => <p key={i}>{p}</p>)}
                <div className="row mt-4">
                    <div className="col-md-6 col-sm-6 col-12">
                        <div className="p-details-img">
                            <img src={serviceImg2} alt={sTitle + " - photo 1"} />
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-6 col-12">
                        <div className="p-details-img">
                            <img src={serviceImg3} alt={sTitle + " - photo 2"} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="service-single-item list-widget">
                <div className="service-single-title">
                    <h3>{t.scopeTitle}</h3>
                </div>
                <ul>
                    {t.scopeList.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
            </div>
            <div className="service-single-item">
                <div className="service-single-title">
                    <h3>{t.whyTitle}</h3>
                </div>
                <p>{t.why}</p>
            </div>
        </div>
    );
};

export default ServicesServiceContent;